import { Log, User, UserManager } from 'oidc-client';

export class DdplanOidcService {
  public userManager: UserManager;
  
  constructor() {
    const settings = {
      authority: `${process.env.REACT_APP_IDM_ENDPOINT}/realms/demo-page-pdmo`,
      client_id: "pdmo-portals",
      response_type: "code",
      scope: "openid profile email",
      automaticSilentRenew: false,
      monitorSession: false,
      loadUserInfo: true,
      redirect_uri: window.location.origin + '/ddplan/signin-callback',
      post_logout_redirect_uri: window.location.origin + '/', // ✅ DDPLAN logout ไป "/"
    };

    this.userManager = new UserManager(settings);

    Log.logger = console;
    Log.level = Log.INFO;
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    window.localStorage.setItem("auth_system", "ddplan");
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  // public async logout(): Promise<void> {
  //   console.log("DDPLAN logout (app only)");

  //   // ล้างเฉพาะของ DDPLAN
  //   localStorage.removeItem("access_token");
  //   localStorage.removeItem("auth_system");

  //   // ลบ user จาก oidc-client
  //   await this.userManager.removeUser();
  //   await this.userManager.clearStaleState();

  //   // redirect กลับระบบกลาง
  //   window.location.replace(
  //     process.env.REACT_APP_IDM_ENDPOINT || "https://onepdmo.pdmo.go.th"
  //   );
  // }

  public async logout(): Promise<void> {
    console.log("DDPLANOidcService.logout");
    localStorage.removeItem("access_token");
    localStorage.removeItem("auth_system");
    await this.userManager.removeUser();
    await this.userManager.clearStaleState();
    window.location.href = process.env.REACT_APP_IDM_ENDPOINT || "https://onepdmo.pdmo.go.th";
  }
}